// ==============================================
// ==================Import======================
// ==============================================

// ================Dépendance====================
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// ================Material-UI===================
import Slider from '@mui/material/Slider';

// ==================Style&IMG===================
import './style.scss';
import { setRadiusValue, setValueChange } from '../../../actions/site';

function SliderRadius({ radius }) {
  // ====================HOOK======================

  const dispatch = useDispatch();

  // ==================Champs Controllés==========

  // handler champ contollé slider material UI
  const handleSliderValue = (event) => {
    dispatch(setRadiusValue(event.target.value));
    dispatch(setValueChange(true));
  };

  return (
    <div className="box">
      <Slider
        className="box__slider"
        aria-label="Radius Km"
        defaultValue={0}
        step={10}
        min={0}
        max={1500}
        valueLabelDisplay="auto"
        value={radius}
        onChange={handleSliderValue}
      />
    </div>
  );
}

SliderRadius.propTypes = {
  radius: PropTypes.number.isRequired,
};

export default SliderRadius;
